import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery , takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import * as Api from 'api';

/***************************** Selectors ************************************/
const getJobs = state => (state.jobs);

/***************************** Subroutines ************************************/
function * fetchJob( action ) {
  try {

    const job = yield call(Api.fetchJob, action.payload.id);
    if(job) {
      yield put(Actions.addJob(job));
      yield put(Actions.previewJob(job._id));
    }
  }
  catch(ex) {
    console.error(ex)
  }
}

function * fetchJobs( { payload } ) {
  const defaults = yield select(getJobs);

  const size = typeof payload.size !== 'undefined' ? payload.size: defaults.size;
  const keywords = typeof payload.keywords !== 'undefined' ? payload.keywords : defaults.keywords;
  const sort = typeof payload.sort !== 'undefined' ? payload.sort : defaults.sort;
  const offset = typeof payload.offset !== 'undefined'? payload.offset: 0;
  const filters = typeof payload.filters !== 'undefined'? payload.filters: defaults.current_filters;
  const { client, show_closed } = payload;
  try {
    const fetched = yield call(Api.fetchJobs, {
      size,
      keywords,
      sort,
      offset,
      filters,
      client,
      show_closed
    });

    yield put(Actions.recieveJobs(fetched));
  }
  catch(ex) {
    yield put(Actions.notify(ex));
  }
}

function * fetchNextJobs( action ) {
  const { size, offset, total, current_filters, keywords } = yield select(getJobs);

  if(size * (offset + 1) - total < 0) {
    const fetched = yield call(Api.fetchJobs, { size, offset : offset + 1, filters : current_filters, keywords, client : action.payload.client, show_closed: action.payload.show_closed })
    yield put(Actions.recieveNextJobs(fetched));
  }
  else {
    yield put({
      type : ActionTypes.FETCH_NEXT_JOBS_FAILED,
      payload : { message : "No more jobs with those filters."}
    })
  }
}

function * fetchJobsFilters( action ) {
  const { metadata } = yield call(Api.fetchJobMetadata);
  yield put(Actions.recieveJobsFilters(metadata));
}

function * createJob( action ) {
  yield put(Actions.sendSocketEmit({
    job: action.payload.job
  }, 'create-job'));
}

function * createJobSuccess( action ) {
  yield put(Actions.hideCreateJob());
  yield put(Actions.clearClient());
  yield put(Actions.notify({ title: 'Success!', message : 'Opportunity created!'}, {type : 'success'}))
  yield put(Actions.previewJob(action.payload.job));
}

function * createJobFailed( action ) {
  yield put(Actions.notify({ message : action.payload.message }));
}

function * deleteJob( action ) {
  try {
    yield put(Actions.sendSocketEmit({
      job : action.payload.job._id || action.payload.job
    }, 'delete-job'));
    yield put(Actions.toggleShowDeleteJobConfirm(false))
  }
  catch(ex) {
    yield put(Actions.toggleShowDeleteJobConfirm(false))
    yield put({type: ActionTypes.DELETE_JOB_FAILED, payload: {...ex} });
  }
}

function * deleteJobFailed( action ) {
  yield put(Actions.notify(action.payload));
}

function * deleteJobSuccess( action ) {
  //TODO: Implement.
  yield put(Actions.removeJob(action.payload.job));
}

function * updateJobSuccess( action ) {
  // yield put(Actions.notify({ title : 'Success!', message : 'Opportunity updated.'}, {type : 'success'}));
  yield put(Actions.updateJob(action.payload.job));
}
function * updateSummary() {
  const summary = yield call(Api.fetchOpporunitiesSummary);
  yield put(Actions.updatePipelineSummary(summary));
}
/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function * jobsWatcher() {
  yield * [
    takeLatest(ActionTypes.UPDATE_JOB_SUCCESS, updateJobSuccess),
    takeLatest(ActionTypes.UPDATE_JOB_SUCCESS, updateSummary),
    takeLatest(ActionTypes.CREATE_JOB, createJob),
    takeLatest(ActionTypes.CREATE_JOB_SUCCESS, createJobSuccess),
    takeLatest(ActionTypes.CREATE_JOB_FAILED, createJobFailed),
    takeLatest(ActionTypes.DELETE_JOB, deleteJob),
    takeLatest(ActionTypes.DELETE_JOB_SUCCESS, deleteJobSuccess),
    takeLatest(ActionTypes.DELETE_JOB_FAILED, deleteJobFailed),
    takeLatest(ActionTypes.FETCH_JOB, fetchJob),
    takeLatest(ActionTypes.FETCH_JOBS, fetchJobs),
    takeLatest(ActionTypes.FETCH_NEXT_JOBS, fetchNextJobs),
    takeEvery(ActionTypes.FETCH_JOBS_FILTERS, fetchJobsFilters),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/jobs.js